import React from "react";
import clsx from "clsx";
import history from "../../helpers/History";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAlert } from "../../store/actions/AppAction";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { loginFatura } from "../../services/UsuarioService";
import Grid from "@material-ui/core/Grid";
import ConfirmAceitaPreFatura from "./ConfirmAceitaPreFatura";
import { Hidden } from "@material-ui/core";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  margin: {
    margin: theme.spacing(1)
  },
  textField: {
    flexBasis: 300
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

class Aprovacao extends React.Component {
  state = {
    showPassword: false,
    password: "",
    user: "",
    empenho: "0",
    openConfirm: false
  };

  handleClose = () => {
    this.props.close();
  };

  handleAprovar = () => { };

  handleClickShowPassword = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  };

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleCloseConfirm = value => {
    this.setState({ openDetalhe: false });
  };

  handleClickOpenAprovacao = () => {
    this.setState({
      openAprovacao: true
    });
  };

  handleClickOpenConfirmaAprovacao = () => {
    this.setState({
      openConfirm: true
    });
  };

  handleCloseConfirmAprovacao = value => {
    //this.setState({ openConfirm: false });
  };

  login = () => {
    loginFatura(this.state.user, this.state.password, this.props.orgao)
      .then(result => {
        if (this.state.empenho) {
          sessionStorage.setItem("idfatura", this.props.fatura);
          sessionStorage.setItem("user", this.state.user);
          sessionStorage.setItem("password", this.state.password);
          sessionStorage.setItem("empenho", this.state.empenho);
          history.push("/ConfirmaFatura/");
        } else {
          this.props.showAlert({
            message: "Informe o empenho!",
            options: {
              variant: "warning",
              anchorOrigin: { vertical: "top", horizontal: "center" }
            }
          });
        }

        console.log(result);
      })
      .catch(error => {
        if (error && error.message && error.message.error) {
          this.props.showAlert({
            message: error.message.error,
            options: {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "center" }
            }
          });
        } else {
          this.props.showAlert({
            message: "Usuário não possui permissão!",
            options: {
              variant: "error",
              anchorOrigin: { vertical: "top", horizontal: "center" }
            }
          });
        }
        console.log(error);
      });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ConfirmAceitaPreFatura
          open={this.state.openConfirm}
          close={this.handleCloseConfirmAprovacao}
        />
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            Aprovar Faturamento
          </DialogTitle>
          <DialogContent
            dividers
            style={
              navigator.userAgent.indexOf("Chrome") !== -1
                ? {}
                : { width: "500px" }
            }
          >
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="stretch"
              spacing={1}
            >
              {/* <Grid item xs={12}>
                <TextField
                  name="empenho"
                  autoComplete="off"
                  className={clsx(classes.margin, classes.textField)}
                  type="text"
                  label="Empenho:"
                  value={this.state.empenho}
                  onChange={this.onChange}
                />
              </Grid> */}

              <TextField
                label="Campo Oculto"
                name="empenho"
                variant="outlined"
                value={'0'}
                style={{ display: 'none' }} // Oculta o campo
              />


              <Grid item xs={12}>
                <TextField
                  name="user"
                  autoComplete="off"
                  className={clsx(classes.margin, classes.textField)}
                  type="text"
                  label="Usuário:"
                  value={this.state.user}
                  onChange={this.onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="password"
                  className={clsx(classes.margin, classes.textField)}
                  type={this.state.showPassword ? "text" : "password"}
                  label="Senha:"
                  value={this.state.password}
                  onChange={this.onChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                        >
                          {this.state.showPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.login} color="primary">
              Aprovar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
Aprovacao.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAlert }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(Aprovacao));
